import { render, staticRenderFns } from "./performanceCards.vue?vue&type=template&id=38208ae4&scoped=true&"
import script from "./performanceCards.vue?vue&type=script&lang=js&"
export * from "./performanceCards.vue?vue&type=script&lang=js&"
import style0 from "./performanceCards.vue?vue&type=style&index=0&id=38208ae4&lang=scss&scoped=true&"
import style1 from "./performanceCards.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./performanceCards.vue?vue&type=style&index=2&id=38208ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38208ae4",
  null
  
)

export default component.exports